import { httpClient } from "@/shared/services/http";

import {
  ICreateScaleAnalysisPayload,
  IScaleAnalysesForTest,
  IScaleAnalysisEntity,
  IUpdateScaleAnalysisPayload,
  LocalizedText,
} from "./scale-analyses.types";

export class ScaleAnalysesHttpService {
  static async getScaleAnalysesForTest(testId: string | number): Promise<IScaleAnalysesForTest> {
    const { data } = await httpClient.get(`/api/tests/${testId}/scale-analyses`);

    return data;
  }

  static async getEligibility(testId: string | number): Promise<{ belongsToAssessmentTemplate: boolean }> {
    const { data } = await httpClient.get(`/api/tests/${testId}/scale-analyses/eligibility`);

    return data;
  }

  static async createScaleAnalysis(
    testId: string | number,
    payload: ICreateScaleAnalysisPayload,
  ): Promise<IScaleAnalysisEntity> {
    const { data } = await httpClient.post(`/api/tests/${testId}/scale-analyses`, payload);

    return data;
  }

  static async updateScaleAnalysis(
    scaleAnalysisId: number,
    payload: IUpdateScaleAnalysisPayload,
  ): Promise<IScaleAnalysisEntity> {
    const { data } = await httpClient.patch(`/api/scale-analyses/${scaleAnalysisId}`, payload);

    return data;
  }

  static async convertToTestSpecific({
    scaleAnalysisId,
    testId,
  }: {
    scaleAnalysisId: number;
    testId: number;
  }): Promise<IScaleAnalysisEntity> {
    const { data } = await httpClient.post(`/api/scale-analyses/${scaleAnalysisId}/convert`, { testId });

    return data;
  }

  static async updateScaleDisplayName(scaleId: number, displayName: LocalizedText): Promise<void> {
    await httpClient.patch(`/api/scales/${scaleId}`, { displayName });
  }
}
